function buildThumbnailSrc(fullSrc) {
  const lastSlash = fullSrc.lastIndexOf("/");
  if (lastSlash === -1) {
    return fullSrc;
  }

  const directory = fullSrc.slice(0, lastSlash);
  const filename = fullSrc.slice(lastSlash + 1);
  return `${directory}/thumbnails/${filename}`;
}

function createStaticImageAsset(fullSrc, metadata = {}) {
  return {
    ...metadata,
    fullSrc,
    thumbnailSrc: buildThumbnailSrc(fullSrc),
  };
}

export const MONTHLY_STATS_IMAGES = [
  createStaticImageAsset("/imgs/monthly-newsletter/8-mcverse-september-2024-update-stats.jpg", {
    id: "2024-09",
    date: "September-2024",
    title: "September 2024",
  }),
  createStaticImageAsset("/imgs/monthly-newsletter/6-survival-minecraft-mcverse-2024-10-stats.jpg", {
    id: "2024-10",
    date: "October-2024",
    title: "October 2024",
  }),
  createStaticImageAsset("/imgs/monthly-newsletter/4-survival-minecraft-mcverse-2024-11-stats.jpg", {
    id: "2024-11",
    date: "November-2024",
    title: "November 2024",
  }),
  createStaticImageAsset("/imgs/monthly-newsletter/3-mcverse-december-2024-12-stats.jpg", {
    id: "2024-12",
    date: "December-2024",
    title: "December 2024",
  }),
  createStaticImageAsset("/imgs/monthly-newsletter/2-mcverse-january-2025-01-stats.jpg", {
    id: "2025-01",
    date: "January-2025",
    title: "January 2025",
  }),
  createStaticImageAsset("/imgs/monthly-newsletter/2-mcverse-february-2025-02-stats.jpg", {
    id: "2025-02",
    date: "February-2025",
    title: "February 2025",
  }),
  createStaticImageAsset("/imgs/monthly-newsletter/1-survival-minecraft-mcverse-2025-02-stats.jpg", {
    id: "2025-03",
    date: "March-2025",
    title: "March 2025",
  }),
  createStaticImageAsset("/imgs/monthly-newsletter/1-survival-minecraft-mcverse-2025-03-stats.jpg", {
    id: "2025-04",
    date: "April-2025",
    title: "April 2025",
  }),
  createStaticImageAsset("/imgs/monthly-newsletter/mcverse-2025-05-may-minecraft-survival-vanilla-stats.png", {
    id: "2025-05",
    date: "May-2025",
    title: "May 2025",
  }),
  createStaticImageAsset("/imgs/monthly-newsletter/mcverse-2025-06-june-minecraft-survival-vanilla-stats.png", {
    id: "2025-06",
    date: "June-2025",
    title: "June 2025",
  }),
  createStaticImageAsset("/imgs/monthly-newsletter/mcverse-2025-07-july-minecraft-survival-vanilla-stats.png", {
    id: "2025-07",
    date: "July-2025",
    title: "July 2025",
  }),
  createStaticImageAsset("/imgs/monthly-newsletter/mcverse-city-no-reset-smp-1-21-8-survival-no-grief-minecraft-august-city-news.png", {
    id: "2025-08",
    date: "August-2025",
    title: "August 2025",
  }),
  createStaticImageAsset("/imgs/monthly-newsletter/9-mcverse-survival-no-grief-2025-09-stats.jpg", {
    id: "2025-09",
    date: "September-2025",
    title: "September 2025",
  }),
  createStaticImageAsset("/imgs/monthly-newsletter/mcverse-no-grief-no-reset-survival-smp-2025-10-stats.png", {
    id: "2025-10",
    date: "October-2025",
    title: "October 2025",
  }),
  createStaticImageAsset("/imgs/monthly-newsletter/mcverse-survival-no-grief-minecraft-2025-11-stats.jpg", {
    id: "2025-11",
    date: "November-2025",
    title: "November 2025",
  }),
  createStaticImageAsset("/imgs/monthly-newsletter/mcverse-monthly-city-news-minecraft-survival-smp-2025-12-stats.png", {
    id: "2025-12",
    date: "December-2025",
    title: "December 2025",
  }),
  createStaticImageAsset("/imgs/monthly-newsletter/large-rectangle-poster-mcverse-2026-01-stats.png", {
    id: "2026-01",
    date: "January-2026",
    title: "January 2026",
  }),
  createStaticImageAsset("/imgs/monthly-newsletter/large-rectangle-poster-mcverse-2026-02-stats.png", {
    id: "2026-02",
    date: "February-2026",
    title: "February 2026",
  }),
  createStaticImageAsset("/imgs/monthly-newsletter/large-rectangle-poster-mcverse-2026-03-stats.png", {
    id: "2026-03",
    date: "March-2026",
    title: "March 2026",
  }),
  createStaticImageAsset("/imgs/monthly-newsletter/large-rectangle-poster-mcverse-2026-04-stats.jpg", {
    id: "2026-04",
    date: "April-2026",
    title: "April 2026",
  }),
  createStaticImageAsset("/imgs/monthly-newsletter/large-rectangle-poster-mcverse-2026-05-stats.jpg", {
    id: "2026-05",
    date: "May-2026",
    title: "May 2026",
  }),
  createStaticImageAsset("/imgs/monthly-newsletter/large-rectangle-poster-mcverse-2026-06-stats.jpg", {
    id: "2026-06",
    date: "June-2026",
    title: "June 2026",
  }),
];

export const RECENT_MONTHLY_STATS_IMAGES = MONTHLY_STATS_IMAGES.slice(-2).reverse();
export const LATEST_MONTHLY_STATS_IMAGE =
  MONTHLY_STATS_IMAGES[MONTHLY_STATS_IMAGES.length - 1];

export const PLAYER_BUILD_IMAGES = [
  createStaticImageAsset("/imgs/player-builds/2025-01-19_14.33.54.jpg", {
    title: "__Lewis",
    rows: 2,
    cols: 4,
  }),
  createStaticImageAsset("/imgs/player-builds/2023-08-05_11.03.15.jpg", {
    title: "EcS Base",
    rows: 2,
    cols: 2,
  }),
  createStaticImageAsset("/imgs/player-builds/2024-01-22_22.11.43.jpg", {
    rows: 1,
    cols: 2,
  }),
  createStaticImageAsset("/imgs/player-builds/2023-08-11_14.26.41.jpg", {
    title: "BugsBunny93",
  }),
  createStaticImageAsset("/imgs/player-builds/2023-09-14_08.32.10.jpg"),
  createStaticImageAsset("/imgs/player-builds/2025-02-23_02.40.29.jpg", {
    rows: 2,
    cols: 2,
  }),
  createStaticImageAsset("/imgs/player-builds/2024-01-10_15.51.39.jpg", {
    rows: 2,
    cols: 2,
  }),
  createStaticImageAsset("/imgs/player-builds/2024-01-17_19.58.54.jpg", {
    rows: 2,
    cols: 2,
  }),
  createStaticImageAsset("/imgs/player-builds/2024-02-19_22.34.37.jpg"),
  createStaticImageAsset("/imgs/player-builds/2024-02-19_22.39.54.jpg"),
  createStaticImageAsset("/imgs/player-builds/2025-01-28_23.32.39.jpg"),
  createStaticImageAsset("/imgs/player-builds/2024-02-29_22.51.45.jpg"),
  createStaticImageAsset("/imgs/player-builds/DrWho.jpg", {
    cols: 2,
  }),
  createStaticImageAsset("/imgs/player-builds/House.jpg", {
    rows: 1,
    cols: 2,
  }),
  createStaticImageAsset("/imgs/player-builds/hsh.jpg", {
    rows: 2,
    cols: 2,
  }),
  createStaticImageAsset("/imgs/player-builds/image0.jpg", {
    rows: 2,
    cols: 1,
  }),
  createStaticImageAsset("/imgs/player-builds/MinecraftChillin.jpg"),
  createStaticImageAsset("/imgs/player-builds/Night_.jpg"),
  createStaticImageAsset("/imgs/player-builds/preview.jpg", {
    rows: 2,
    cols: 2,
  }),
  createStaticImageAsset("/imgs/player-builds/fishing_getaway.jpg", {
    rows: 2,
    cols: 2,
  }),
  createStaticImageAsset("/imgs/player-builds/2025-01-25_23.29.33.jpg", {
    rows: 2,
    cols: 4,
  }),
  createStaticImageAsset("/imgs/player-builds/2024-11-09_21.10.32.jpg", {
    rows: 2,
    cols: 2,
  }),
  createStaticImageAsset("/imgs/player-builds/2025-01-28_15.56.43.jpg", {
    rows: 1,
    cols: 1,
  }),
  createStaticImageAsset("/imgs/player-builds/Screenshot_2025-02-04_030456.jpg", {
    rows: 1,
    cols: 1,
  }),
  createStaticImageAsset("/imgs/player-builds/2025-02-11_01.53.46.jpg", {
    rows: 1,
    cols: 2,
  }),
];
